exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-error[data-v-14000ce2] {\n  bottom: -10px !important;\n}\n", ""]);

// exports
